<template>
  <v-dialog v-model="dialog" max-width="460" transition="dialog-bottom-transition">
    <v-card class="rounded-xl overflow-hidden elevation-24 border-light">

      <v-img
        height="220"
        src="/other/barrita-proteica-ddl.jpg"
        cover
        class="align-start text-white"
        :gradient="'to bottom, rgba(0,0,0,0.1), rgba(62, 39, 35, 0.9)'"
      >
        <v-btn
          icon="mdi-close"
          variant="text"
          color="white"
          class="position-absolute"
          style="top: 8px; right: 8px; z-index: 10"
          @click="close"
        ></v-btn>

        <div class="pa-5 fill-height d-flex flex-column justify-end">
          <v-chip color="white" size="x-small" variant="flat" class="text-pink-darken-2 font-weight-black mb-2" style="width: fit-content">
            ✨ NUEVO SABOR
          </v-chip>
          <h2 class="text-h4 font-weight-black mb-0">Barra Proteica Dulce de Leche</h2>
          <p class="text-subtitle-2 font-weight-medium">El sabor de siempre, con 15g de proteína</p>
        </div>
      </v-img>

      <v-card-text class="pa-6">
        <div class="d-flex justify-space-around mb-6 py-3 rounded-lg bg-brown-lighten-5 border-dashed">
          <div class="text-center">
            <div class="text-h5 font-weight-black text-brown-darken-3">15g</div>
            <div class="text-caption font-weight-bold text-grey-darken-1">PROTEÍNA</div>
          </div>
          <v-divider vertical class="mx-1"></v-divider>
          <div class="text-center">
            <v-icon icon="mdi-grain" color="brown-darken-2" size="24"></v-icon>
            <div class="text-caption font-weight-bold text-grey-darken-1">ALTA EN<br>FIBRA</div>
          </div>
          <v-divider vertical class="mx-1"></v-divider>
          <div class="text-center">
            <v-icon icon="mdi-seed-outline" color="green-darken-2" size="24"></v-icon>
            <div class="text-caption font-weight-bold text-grey-darken-1">100%<br>VEGETAL</div>
          </div>
        </div>

        <div class="mb-5">
          <p class="text-body-2 text-grey-darken-3 mb-3">
            <v-icon icon="mdi-check-circle" color="brown-darken-1" size="18" class="mr-1"></v-icon>
            <strong>Crocante y deliciosa</strong>, con todo el sabor del dulce de leche.
          </p>
          <p class="text-body-2 text-grey-darken-3 mb-3">
            <v-icon icon="mdi-check-circle" color="brown-darken-1" size="18" class="mr-1"></v-icon>
            <strong>Energía y saciedad</strong> para antes o después de entrenar.
          </p>
          <p class="text-body-2 text-grey-darken-3 mb-3">
            <v-icon icon="mdi-check-circle" color="brown-darken-1" size="18" class="mr-1"></v-icon>
            Un <strong>snack inteligente</strong> para llevar a donde vayas.
          </p>
        </div>

        <div class="d-flex gap-2 mb-2">
          <v-chip size="x-small" variant="outlined" color="grey-darken-1" class="mr-2">SIN SELLOS</v-chip>
          <v-chip size="x-small" variant="outlined" color="grey-darken-1">100% VEGETAL</v-chip>
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pa-6 bg-grey-lighten-5">
        <v-btn
          block
          color="#5D4037"
          size="x-large"
          variant="elevated"
          class="text-none font-weight-black rounded-lg text-white cta-glow"
          @click="accept"
        >
          ¡La quiero probar!
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, defineEmits, onMounted } from 'vue';

const dialog = ref(false);
const emit = defineEmits(['accept']);
const PROMO_SESSION_KEY = 'veggie_promo_ddl_seen';

onMounted(() => {
  try {
    const alreadySeen = sessionStorage.getItem(PROMO_SESSION_KEY);
    if (!alreadySeen) {
      dialog.value = true;
    }
  } catch {
    dialog.value = true;
  }
});

const close = () => {
  dialog.value = false;
  try {
    sessionStorage.setItem(PROMO_SESSION_KEY, 'true');
  } catch {
    // ignorar si el almacenamiento privado está restringido
  }
};

const accept = () => {
  emit('accept');
  close();
};
</script>

<style scoped>
.border-light {
  border: 1px solid rgba(93, 64, 55, 0.2);
}
.border-dashed {
  border: 1.5px dashed #D7CCC8;
}
.cta-glow {
  box-shadow: 0 4px 15px rgba(93, 64, 55, 0.4) !important;
  transition: all 0.3s ease;
}
.cta-glow:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(93, 64, 55, 0.6) !important;
}
</style>
